unit App.Server.Responses;

interface

uses
  Generics.Collections;

type
  TServerResponse = class
    Status: string;
    Success: Boolean;

    constructor Create(ASuccess: Boolean; AStatus: string);

  end;

  TServerResponseList = class
    ServerResponses: TList<TServerResponse>;

    constructor Create;
    destructor Destroy; override;

  end;

implementation

constructor TServerResponse.Create(ASuccess: Boolean; AStatus: string);
begin
  Status := AStatus;
  Success := ASuccess;

end;

constructor TServerResponseList.Create;
begin
  inherited;

  ServerResponses := TList<TServerResponse>.Create;

end;

destructor TServerResponseList.Destroy;
begin
  ServerResponses.Free;

  inherited;

end;

end.
